import type { PillarPosition } from '../types/pillars';

const PILLAR_ORDER: Record<PillarPosition, number> = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
};

/** 두 기둥이 인접한지 판별 (연-월, 월-일, 일-시) */
export function isAdjacentPillar(a: PillarPosition, b: PillarPosition): boolean {
  return Math.abs(PILLAR_ORDER[a] - PILLAR_ORDER[b]) === 1;
}
